import axios from "axios";

export default function PurchaseorderStatusChangeOrderedService(orderId) {
  return axios({
    method: 'put',
    url: process.env.REACT_APP_API_HOST + "/purchase_order/" + orderId + "/status_change_ordered",
    data: {},
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
